<template>
  <div id="app">
    <!-- 导航栏（H5折叠+中英切换） -->
    <header class="header">
      <div class="container header-wrap">

        <div class="logo">
          <img
              src="https://files.abeibei.top/wsycolors/1774778160730/微信图片_20260329174336_438_176.png"
              alt="{{ lang === 'zh' ? '万盛远（美匠亿隆）' : 'Wanshengyuan (Meijiang Yilong)' }}"
              style="height: 80px; object-fit: contain;"
              loading="lazy"
          >
        </div>

        <!-- 移动端菜单按钮（修复点击无作用bug） -->
        <div class="menu-btn" @click="toggleNav">
          <span :class="{ 'active': isNavOpen }"></span>
          <span :class="{ 'active': isNavOpen }"></span>
          <span :class="{ 'active': isNavOpen }"></span>
        </div>

        <!-- 导航+中英切换 -->
        <div class="nav-wrap" :class="{ 'open': isNavOpen }">
          <nav class="nav">
            <ul>
              <li><a
                  href="#home"
                  @click="closeNav"
                  :class="{ 'active': currentNav === 'home' }">{{ lang === 'zh' ? '首页' : 'Home' }}</a></li>
    <li><a
      href="#products"
                @click="closeNav"
                :class="{ 'active': currentNav === 'products' }
                ">{{ lang === 'zh' ? '产品中心' : 'Products' }}</a></li>
              <li><a
                  href="#about"
                  @click="closeNav"
                  :class="{ 'active': currentNav === 'about' }
    ">{{ lang === 'zh' ? '关于我们' : 'About Us' }}</a></li>
    <li><a
      href="#cases"
                @click="closeNav"
                :class="{ 'active': currentNav === 'cases' }
                ">{{ lang === 'zh' ? '工程案例' : 'Cases' }}</a></li>
              <li><a
                  href="#contact"
                  @click="closeNav"
                  :class="{ 'active': currentNav === 'contact' }
    ">{{ lang === 'zh' ? '联系我们' : 'Contact' }}</a></li>
  </ul>
</nav>
          <!-- 中英切换按钮 -->
          <div class="lang-switch">
            <button class="lang-btn" :class="{ active: lang === 'zh' }" @click="lang = 'zh'">中</button>
            <button class="lang-btn" :class="{ active: lang === 'en' }" @click="lang = 'en'">En</button>
          </div>
        </div>
      </div>
    </header>

    <!-- 轮播 banner（H5适配，触摸滑动兼容） -->
    <section id="home" class="banner">
      <div class="banner-content">
        <h1>{{ lang === 'zh' ? '匠心铝材，筑造美好' : 'Quality Aluminum, Build Better' }}</h1>
        <p>
          {{
            lang === 'zh'
                ? '铝方通 | 铝单板 | 铝窗花 | 铝方管 | 铝格栅 | 铝天花 | 全品类铝型材 一站式定制 & 批发'
                : 'Aluminum Baffle / Aluminum Panel / Aluminum Lattice / Aluminum Tube / Aluminum Grid / Aluminum Ceiling / One-stop Custom & Wholesale'
          }}
        </p>
        <button class="btn" onclick="document.getElementById('contact').scrollIntoView({behavior: 'smooth'})">
          {{ lang === 'zh' ? '立即咨询' : 'Consult Now' }}
        </button>
      </div>
    </section>

    <!-- 产品中心（中英产品名+响应式布局） -->
    <section id="products" class="section products">
      <div class="container">
        <div class="title">
          <h2>{{ lang === 'zh' ? '产品中心' : 'Product Center' }}</h2>
          <p>
            {{
              lang === 'zh'
                  ? '专注高端铝材生产，支持定制、工程供货、厂家直销'
                  : 'Focus on high-end aluminum production, supporting customization, project supply and direct sales'
            }}
          </p>
        </div>
        <div class="product-list">
          <div class="product-item" v-for="item in products" :key="item.id">
            <div class="product-img">
              <img :src="item.img" :alt="lang === 'zh' ? item.name : item.nameEn">
            </div>
            <div class="product-info">
              <h3>{{ lang === 'zh' ? item.name : item.nameEn }}</h3>
              <p>{{ lang === 'zh' ? item.desc : item.descEn }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们（中英文案） -->
    <section id="about" class="section about">
      <div class="container about-wrap">
        <div class="about-img">
          <img src="https://picsum.photos/id/1048/600/400" :alt="lang === 'zh' ? '工厂实景' : 'Factory Scene'">
        </div>
        <div class="about-text">
          <div class="title" style="text-align: left;">
            <h2>{{ lang === 'zh' ? '关于我们' : 'About Us' }}</h2>
          </div>
          <p>
            {{
              lang === 'zh'
                  ? ' 佛山市万盛远（美匠亿隆）装饰材料有限公司，成立于2015年，是一家集研发、生产、销售及安装工程为一体的新型建材企业。专业从事研发、生产、销售铝单板、铝卷原料、铝方通、长城格、条扣、格栅、挂片、铝方管等。公司努力致力于技术的创新，相应国家“节能减排”的号召，产品始终站在行业的前列。公司拥有30余台生产加工设备，原材料备料充足，可以分任意开料，产品丰富多样，解决行业有机器没材料的痛点、解决有订单定料慢的痛点、解决异型开料规格没材料的痛点。'
                  : 'We are a large-scale aluminum enterprise integrating R&D, production and sales, with modern production bases, advanced equipment and professional teams.'
            }}
          </p>
          <p>
            {{
              lang === 'zh'
                  ? ' 公司主要服务于全国各地建筑装饰公司及大型项目装饰，广泛用于政府办公楼、星级酒店、大型商城、会展中心、地铁站、机场、体育馆、医院、学校、厂房、高速服务区及家庭吊顶等。'
                  : 'We are a large-scale aluminum enterprise integrating R&D, production and sales, with modern production bases, advanced equipment and professional teams.'
            }}
          </p>
          <p>
            {{
              lang === 'zh'
                  ? ' 佛山市万盛远（美匠亿隆）装饰材料有限公司一直注重品牌质量的建立于分享，秉承“创造永无止境”的理念与精神。以“诚信、求实、创新、互利”为企业精神。以人为本、以创新为导向、以成本为核心、以质量为保障的发展理念，不断为客户提供优质的产品，满意的服务。做到诚信铸就品牌，质量赢取市场的经营理念。随着模范工程的打造，得到市场积极的肯定，是不懈追求的动力。'
                  : 'Main products: Aluminum Square Tube, Aluminum Panel, Aluminum Grille, Aluminum Square Pipe, Ceiling Hanging Pipe, Aluminum Great Wall-Wave Panel Series, etc., widely used in office buildings, shopping malls, airports, subway stations, hotels and other projects.'
            }}
          </p>
          <button class="btn" style="margin-top: 20px;"
                  onclick="document.getElementById('contact').scrollIntoView({behavior: 'smooth'})">
            {{ lang === 'zh' ? '了解更多' : 'Learn More' }}
          </button>
        </div>
      </div>
    </section>

    <!-- 工程案例（中英适配，修复图片横屏占满） -->
    <section id="cases" class="section cases" style="background: var(--light);">
      <div class="container">
        <div class="title">
          <h2>{{ lang === 'zh' ? '工程案例' : 'Project Cases' }}</h2>
          <p>
            {{
              lang === 'zh' ? '多年行业经验，服务全国上千个工程项目' : 'Years of industry experience, serving thousands of projects nationwide'
            }}
          </p>
        </div>
        <div class="case-list">
          <div class="case-item" v-for="item in cases" :key="item.id">
            <img :src="item.img" :alt="lang === 'zh' ? item.name : item.nameEn" style="width: 100%;">
            <div class="case-name">{{ lang === 'zh' ? item.name : item.nameEn }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们（中英适配） -->
    <section id="contact" class="section contact">
      <div class="container">
        <div class="title">
          <h2>{{ lang === 'zh' ? '联系我们' : 'Contact Us' }}</h2>
          <p>
            {{
              lang === 'zh' ? '欢迎莅临佛山市万盛远（美匠亿隆）装饰材料有限公司！' : 'Welcome to Foshan WSY (Meijiang Yilong) Decoration Materials Co., Ltd.'
            }}
          </p>
          <p>
            {{
              lang === 'zh' ? '源头厂家直销，无中间差价。请留下您的规格需求，我们将为您提供最直接的出厂报价' : 'Direct from the manufacturer, no middlemen involved. Please leave your specifications and we will provide you with the most direct factory quote.'
            }}
          </p>
        </div>
        <div class="contact-wrap">
          <div class="contact-info">
            <div class="info-item">
              <h3><svg t="1776176813273" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6820" width="32" height="32"><path d="M647.786667 845.397333c-76.053333-24.234667-157.248-76.266667-240.917334-163.648-81.152-84.757333-131.626667-164.864-157.504-238.442666-16.832-47.829333-21.056-85.546667-18.581333-111.402667a50.986667 50.986667 0 0 1 0.384-3.221333l0.341333-3.349334c0.469333-18.112 10.922667-46.144 22.122667-59.264a414.677333 414.677333 0 0 1 34.56-39.466666c9.834667-9.877333 19.306667-18.133333 27.946667-24.192 12.885333-9.045333 21.162667-11.328 23.317333-10.069334-0.213333 0.021333 1.045333 1.322667 2.837333 3.776 3.157333 4.288 7.082667 10.517333 11.669334 18.410667a1030.4 1030.4 0 0 1 31.04 59.264 3473.109333 3473.109333 0 0 1 58.368 126.229333c1.706667 3.84 0.938667 12.309333-1.344 15.722667l-47.04 69.824a27.52 27.52 0 0 0-3.370667 7.424c-7.509333 25.92 12.309333 66.517333 73.834667 129.216 37.504 38.186667 70.293333 63.061333 98.496 77.077333 18.944 9.429333 33.28 12.8 42.730666 12.586667 4.48-0.192 8.256-1.450667 11.52-3.626667l69.546667-46.933333c3.584-2.410667 12.416-3.349333 16.533333-1.685333l8.704 3.477333a3178.794667 3178.794667 0 0 1 91.477334 38.464c7.04 3.114667 13.802667 6.144 20.266666 9.088 21.76 9.962667 39.637333 18.773333 52.629334 25.984 6.784 3.797333 12.074667 7.061333 15.573333 9.642667 1.429333 1.066667 2.432 1.877333 2.901333 2.346666a10.602667 10.602667 0 0 1-2.197333-3.968l1.472 3.2c4.522667 8.064-16.853333 38.122667-51.562667 68.714667a626.624 626.624 0 0 1-20.544 17.344 21.333333 21.333333 0 1 0 26.453334 33.450667 669.056 669.056 0 0 0 22.293333-18.794667c52.48-46.293333 80.661333-85.866667 60.544-121.642667l1.472 3.2c-6.037333-16.64-32.277333-31.274667-91.306667-58.261333-6.613333-3.050667-13.546667-6.144-20.736-9.322667a2876.629333 2876.629333 0 0 0-101.610666-42.538666c-17.109333-6.912-40.874667-4.416-56.234667 5.930666l-69.546667 46.933334 10.922667-3.626667c0.576-0.021333-0.554667-0.149333-2.986667-0.725333a92.693333 92.693333 0 0 1-19.306666-7.424c-23.68-11.776-52.693333-33.792-87.04-68.778667-51.797333-52.757333-65.322667-80.490667-63.317334-87.445333a16.021333 16.021333 0 0 1-1.92 4.074666l46.741334-69.376c10.474667-15.573333 12.586667-39.530667 5.013333-56.725333l-4.138667-9.365333a3937.258667 3937.258667 0 0 0-46.122666-100.202667c-3.029333-6.293333-5.973333-12.416-8.874667-18.304-30.997333-63.082667-48.512-93.290667-64.213333-100.48-18.922667-11.157333-42.261333-4.672-67.456 12.992-10.922667 7.658667-22.186667 17.472-33.642667 28.970667a456.597333 456.597333 0 0 0-37.610667 42.88c-16.853333 19.712-30.805333 57.173333-31.509333 84.906666l0.341333-3.349333c-0.277333 1.493333-0.597333 3.797333-0.896 6.954667-3.050667 31.893333 1.877333 75.818667 20.821334 129.621333 27.946667 79.466667 81.664 164.736 166.912 253.781333 88.490667 92.416 175.765333 148.330667 258.773333 174.805334 27.797333 8.853333 53.888 13.952 77.973333 15.957333a21.333333 21.333333 0 0 0 3.52-42.517333 310.570667 310.570667 0 0 1-68.522666-14.08z" fill="#d81e06" p-id="6821"></path></svg> {{ lang === 'zh' ? '咨询电话' : 'Contact us' }}</h3>
              <p>+86-17796009174</p>
              <p>+86-18138308172</p>
            </div>
            <div class="info-item">
              <h3><svg t="1776176773838" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5649" width="32" height="32"><path d="M541.190891 1009.293248C544.52832 1005.885275 548.383707 1001.898704 552.713978 997.36109 565.025302 984.460186 578.71838 969.688892 593.450024 953.266626 635.514509 906.374618 677.575463 855.548152 716.899743 802.505285 772.694379 727.246301 818.336558 653.733231 850.310552 583.915306 882.791737 512.990107 900.380982 447.547911 900.380982 388.380982 900.380982 173.884097 726.496814 0 512 0 297.503186 0 123.619018 173.884097 123.619018 388.380982 123.619018 453.914994 148.112442 529.89656 192.638909 615.024269 222.801105 672.689965 261.563999 733.327147 306.917011 795.635831 346.163792 849.555204 388.144069 901.753449 430.125229 950.301866 444.824743 967.300737 458.485691 982.641645 470.765062 996.079009 475.081033 1000.802039 478.922121 1004.956003 482.24525 1008.510078 484.268362 1010.673642 485.687365 1012.175194 486.459184 1012.983838 500.133902 1027.31116 522.916683 1027.589594 536.93759 1013.600746 537.722472 1012.817576 539.154539 1011.372534 541.190891 1009.293248ZM537.540816 964.228432C536.933529 963.592087 535.680295 962.265819 533.824363 960.28098 530.682538 956.921044 527.024342 952.964783 522.892674 948.443587 511.036286 935.468873 497.80291 920.608075 483.539265 904.113199 442.768795 856.965196 401.997442 806.270003 364.009369 754.079684 320.553597 694.377636 283.599147 636.569422 255.210969 582.295634 215.493894 506.362491 194.233742 440.41104 194.233742 388.380982 194.233742 212.883532 336.502462 70.614724 512 70.614724 687.497538 70.614724 829.766258 212.883532 829.766258 388.380982 829.766258 436.039636 814.709257 492.060238 786.108175 554.512959 756.432867 619.311431 713.270146 688.831132 660.173876 760.450492 622.263303 811.586462 581.572627 860.7571 540.885482 906.113538 526.654144 921.978212 513.452721 936.219066 501.628286 948.609655 497.511094 952.924056 493.867022 956.692128 490.739495 959.885697 488.896804 961.767332 487.65681 963.018643 487.06241 963.611524L537.540816 964.228432ZM670.883129 388.380982C670.883129 300.632248 599.748681 229.497853 512 229.497853 424.251319 229.497853 353.116871 300.632248 353.116871 388.380982 353.116871 476.129715 424.251319 547.26411 512 547.26411 599.748681 547.26411 670.883129 476.129715 670.883129 388.380982ZM423.731595 388.380982C423.731595 339.631683 463.250772 300.112577 512 300.112577 560.749228 300.112577 600.268405 339.631683 600.268405 388.380982 600.268405 437.13028 560.749228 476.649387 512 476.649387 463.250772 476.649387 423.731595 437.13028 423.731595 388.380982Z" fill="#d81e06" p-id="5650"></path></svg> {{ lang === 'zh' ? '工厂地址' : 'Factory Address' }}</h3>
              <p>{{
                  lang === 'zh' ? '广东省佛山市南海区狮山镇罗村沙缇机场路105号' : 'No. 105, Shati Airport Road, Luocun Village, Shishan Town, Nanhai District, Foshan City, Guangdong Province'
                }}</p>
            </div>
            <div class="info-item">
              <h3><svg t="1776176716320" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3111" width="32" height="32"><path d="M735.872 968.96H241.28c-112.256 0-203.264-91.008-203.264-203.264V271.104C38.016 158.848 129.024 67.84 241.28 67.84h494.592c112.256 0 203.264 91.008 203.264 203.264v494.592c0 112.256-91.008 203.264-203.264 203.264z" fill="#00A9FA" p-id="3112"></path><path d="M538.112 560.768L768 330.88c-5.504-3.328-11.776-4.736-18.304-4.736H227.84c-5.76 0-11.52 1.28-16.64 3.712l230.912 230.912c26.368 26.368 69.376 26.368 96 0zM192.384 346.752c-3.584 6.016-5.504 12.8-5.504 20.096v302.976c0 8.32 2.56 15.872 6.784 22.144l172.8-171.52-174.08-173.696z" fill="#FFFFFF" p-id="3113"></path><path d="M555.648 578.432c-17.408 17.664-40.704 27.392-65.664 27.392-24.832 0-48.256-9.856-65.92-27.392l-39.936-39.936-170.88 169.088c4.48 2.048 9.344 3.072 14.592 3.072h521.856c7.04 0 13.568-1.792 19.328-5.248L597.888 536.192l-42.24 42.24zM785.792 348.544L615.808 518.272l170.496 168.96c2.56-5.248 3.968-11.008 3.968-17.408V366.848c0-6.528-1.408-12.8-4.48-18.304z" fill="#FFFFFF" p-id="3114"></path></svg> {{ lang === 'zh' ? '商务邮箱' : 'Business Email' }}</h3>
              <p>pinglinice@163.com</p>
            </div>
            <div class="info-item">
              <h3><svg t="1776176744199" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4347" width="32" height="32"><path d="M337.387283 341.82659c-17.757225 0-35.514451 11.83815-35.514451 29.595375s17.757225 29.595376 35.514451 29.595376 29.595376-11.83815 29.595376-29.595376c0-18.49711-11.83815-29.595376-29.595376-29.595375zM577.849711 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763zM501.641618 401.017341c17.757225 0 29.595376-12.578035 29.595376-29.595376 0-17.757225-11.83815-29.595376-29.595376-29.595375s-35.514451 11.83815-35.51445 29.595375 17.757225 29.595376 35.51445 29.595376zM706.589595 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763z" fill="#28C445" p-id="4348"></path><path d="M510.520231 2.959538C228.624277 2.959538 0 231.583815 0 513.479769s228.624277 510.520231 510.520231 510.520231 510.520231-228.624277 510.520231-510.520231-228.624277-510.520231-510.520231-510.520231zM413.595376 644.439306c-29.595376 0-53.271676-5.919075-81.387284-12.578034l-81.387283 41.433526 22.936416-71.768786c-58.450867-41.433526-93.965318-95.445087-93.965317-159.815029 0-113.202312 105.803468-201.988439 233.803468-201.98844 114.682081 0 216.046243 71.028902 236.023121 166.473989-7.398844-0.739884-14.797688-1.479769-22.196532-1.479769-110.982659 1.479769-198.289017 85.086705-198.289017 188.67052 0 17.017341 2.959538 33.294798 7.398844 49.572255-7.398844 0.739884-15.537572 1.479769-22.936416 1.479768z m346.265896 82.867052l17.757225 59.190752-63.630058-35.514451c-22.936416 5.919075-46.612717 11.83815-70.289017 11.83815-111.722543 0-199.768786-76.947977-199.768786-172.393063-0.739884-94.705202 87.306358-171.653179 198.289017-171.65318 105.803468 0 199.028902 77.687861 199.028902 172.393064 0 53.271676-34.774566 100.624277-81.387283 136.138728z" fill="#28C445" p-id="4349"></path></svg> {{ lang === 'zh' ? '微信咨询' : 'WeChat Consultation' }}</h3>
              <img
                  src="https://files.abeibei.top/wsycolors/1784187335338/32ec5954-3fdf-48b5-8c7a-34de22dd8332.png" alt="{{ lang === 'zh' ? '微信咨询二维码' : 'WeChat Consultation QR Code' }}"
              style="width: 150px; height: 150px; margin: 0 auto; display: block;"
              loading="lazy"
              >
              <p style="margin-top: 10px;">{{ lang === 'zh' ? '扫描二维码，添加微信咨询' : 'Scan QR Code to add WeChat for consultation' }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部（中英版权信息） -->
    <footer class="footer">
      <div class="container">
        <p>
          {{
            lang === 'zh'
                ? '© 2026 佛山市万盛远（美匠亿隆）装饰材料有限公司 版权所有 '
                : '© 2026 Foshan WSY (Meijiang Yilong) Decoration Materials Co., Ltd. All Rights Reserved '
          }}
        </p>
        <p>
          {{
            lang === 'zh'
                ? '主营：铝方通、铝单板、铝窗花、铝方管、天花吊管、长城板、波浪板、铝格栅、条扣、铝天花系列'
                : 'Main Products: Aluminum Square Tube, Panel, Grille, Square Pipe, Ceiling Pipe, Great Wall Board, Wave Board, Strip Buckle, Aluminum Ceiling Series'
          }}
        </p>
        <p class="beian-info">
          <!-- 公安备案图标（官方永久地址） -->
          <img
              src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png"
              alt="公安备案"
              class="beian-icon"
              loading="lazy"
          >
          <!-- ICP备案号 -->
          <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" class="beian-link">
            {{ lang === 'zh' ? '粤ICP备2026038156号-1' : 'Guangdong ICP Registration No. 2026038156-1' }}
          </a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref } from 'vue';

// 自动获取系统/浏览器语言
const getSystemLang = () => {
  const navLang = navigator.language || navigator.userLanguage;
  return navLang.toLowerCase().startsWith('zh') ? 'zh' : 'en';
};

// 中英切换：默认自动识别系统语言
const lang = ref(getSystemLang());

// 移动端导航折叠状态
const isNavOpen = ref(false);

// 切换导航显示/隐藏（修复点击无作用bug）
const toggleNav = () => {
  isNavOpen.value = !isNavOpen.value;
};

// 点击导航项关闭导航（移动端）
const closeNav = () => {
  if (window.innerWidth <= 768) {
    isNavOpen.value = false;
  }
};

// 产品列表（中英双语，包含所有主营产品）
const products = [
  {
    id: 1,
    name: "铝方通",
    nameEn: "Aluminum Square Tube",
    desc: "吊顶专用，规格齐全，防火防潮，安装便捷",
    descEn: "Special for ceiling, complete specifications, fireproof and moisture-proof, easy to install",
    img: "https://files.abeibei.top/wsycolors/1774780742790/微信图片_20260329182136_84_122.jpg"
  },
  {
    id: 2,
    name: "铝单板",
    nameEn: "Aluminum Panel",
    desc: "外墙装饰，氟碳喷涂，耐候性强，支持定制",
    descEn: "Exterior wall decoration, fluorocarbon spraying, strong weather resistance, customizable",
    img: "https://files.abeibei.top/wsycolors/1774780779345/微信图片_20260329182257_86_122.jpg"
  },
  {
    id: 3,
    name: "铝窗花",
    nameEn: "Aluminum Grille",
    desc: "中式仿古装饰，防盗美观，款式可定制",
    descEn: "Chinese style antique decoration, anti-theft and beautiful, customizable styles",
    img: "https://files.abeibei.top/wsycolors/1774780800612/微信图片_20260329182421_87_122.jpg"
  },
  {
    id: 4,
    name: "铝方管",
    nameEn: "Aluminum Square Pipe",
    desc: "结构坚固，用途广泛，可加工定制",
    descEn: "Solid structure, wide range of uses, processable and customizable",
    img: "https://files.abeibei.top/wsycolors/1774780821325/微信图片_20260329182453_88_122.jpg"
  },
  {
    id: 5,
    name: "天花吊管",
    nameEn: "Ceiling Hanging Pipe",
    desc: "吊顶龙骨配套，承重好，施工方便",
    descEn: "Matching with ceiling keel, good load-bearing, convenient construction",
    img: "https://files.abeibei.top/wsycolors/1774780844322/微信图片_20260329182713_89_122.jpg"
  },
  {
    id: 6,
    name: "铝型材长城-波浪板系列",
    nameEn: "Aluminum Profile Great Wall-Wave Panel Series",
    desc: "立体造型，内外墙装饰，质感高级",
    descEn: "Three-dimensional shape, interior and exterior wall decoration, high texture",
    img: "https://files.abeibei.top/wsycolors/1774780891245/微信图片_20260329182901_90_122.jpg"
  },
  {
    id: 7,
    name: "铝长城板系列",
    nameEn: "Aluminum Great Wall Board Series",
    desc: "凹凸造型，护墙吊顶通用，耐用易装",
    descEn: "Concave-convex shape, universal for wall protection and ceiling, durable and easy to install",
    img: "https://files.abeibei.top/wsycolors/1774780913378/微信图片_20260329182921_91_122.jpg"
  },
  {
    id: 8,
    name: "铝格栅天花系列",
    nameEn: "Aluminum Grille Ceiling Series",
    desc: "通透式吊顶，通风散热，简约大气",
    descEn: "Transparent ceiling, ventilation and heat dissipation, simple and elegant",
    img: "https://files.abeibei.top/wsycolors/1774780937106/微信图片_20260329182956_92_122.jpg"
  },
  {
    id: 9,
    name: "条扣系列",
    nameEn: "Strip Buckle Series",
    desc: "长条天花，无缝拼接，适合工装吊顶",
    descEn: "Long strip ceiling, seamless splicing, suitable for industrial ceiling",
    img: "https://files.abeibei.top/wsycolors/1774780958961/微信图片_20260329183011_93_122.jpg"
  },
  {
    id: 10,
    name: "铝扣板系列",
    nameEn: "Aluminum ceiling panels",
    desc: "集成吊顶，家装工装通用，款式丰富",
    descEn: "Integrated ceiling, universal for home and industrial use, rich styles",
    img: "https://files.abeibei.top/wsycolors/1774781102947/微信图片_20260329184454_96_122.jpg"
  }
];

// 工程案例（中英双语）
const cases = [
  {id: 1, name: "铝方通", nameEn: "Aluminum square tube", img: "https://files.abeibei.top/wsycolors/1774773826730/微信图片_20260329164303_72_122.jpg"},
  {id: 2, name: "铝单板", nameEn: "Aluminum single panel", img: "https://files.abeibei.top/wsycolors/1774774086538/微信图片_20260329164749_73_122.jpg"},
  {id: 3, name: "铝窗花", nameEn: "Aluminum window grilles", img: "https://files.abeibei.top/wsycolors/1774780431959/微信图片_20260329183339_95_122.jpg"},
  {id: 4, name: "铝方管", nameEn: "Aluminum square tube", img: "https://files.abeibei.top/wsycolors/1774776721581/微信图片_20260329173154_77_122.jpg"},
  {id: 5, name: "天花吊管", nameEn: "Ceiling pipes", img: "https://files.abeibei.top/wsycolors/1774777099627/微信图片_20260329173743_78_122.jpg"},
  {id: 6, name: "波浪板", nameEn: "wave board", img: "https://files.abeibei.top/wsycolors/1774778963273/微信图片_20260329180511_80_122.jpg"},
  {id: 7, name: "长城板", nameEn: "Great Wall Board", img: "https://files.abeibei.top/wsycolors/1774778490144/微信图片_20260329174309_79_122.png"},
  {id: 8, name: "格栅天花", nameEn: "Grille ceiling", img: "https://files.abeibei.top/wsycolors/1774779069119/微信图片_20260329181042_81_122.jpg"},
  {id: 9, name: "铝条扣", nameEn: "Aluminum strip buckle", img: "https://files.abeibei.top/wsycolors/1774779255203/微信图片_20260329181354_82_122.jpg"},
  {id: 10, name: "铝天花", nameEn: "Aluminum ceiling panels", img: "https://files.abeibei.top/wsycolors/1774779445444/微信图片_20260329181555_83_122.png"}
];

// 监听窗口大小，适配移动端导航
window.addEventListener('resize', () => {
  if (window.innerWidth > 768) {
    isNavOpen.value = false;
  }
});
// 导航选中状态监听，自动匹配当前页面模块
const currentNav = ref('home');

// 修复核心：解决工程案例与联系我们同屏显示时，联系我们无法高亮的问题
// 逻辑优化：优先判定底部模块（联系我们），同屏时优先选中联系我们，避免冲突
window.addEventListener('scroll', () => {
  const sections = ['home', 'products', 'about', 'cases', 'contact'];
  let currentSection = 'home';

  // 反向遍历（从底部联系我们开始判定），同屏时优先选中靠下的模块
  for (let i = sections.length - 1; i >= 0; i--) {
    const section = sections[i];
    const dom = document.getElementById(section);
    if (dom) {
      const rect = dom.getBoundingClientRect();
      // 优化判定：模块顶部进入可视区域（top <= 200），且模块有部分在可视区域内（bottom > 0）
      // 适配同屏显示场景，底部模块优先选中
      if (rect.top <= 200 && rect.bottom > 0) {
        currentSection = section;
        break; // 找到符合条件的模块，立即终止遍历，避免冲突
      }
    }
  }

  // 强制同步选中状态，确保联系我们在同屏时优先高亮
  currentNav.value = currentSection;

  // 点击导航跳转后，手动同步选中状态（补充兜底，避免跳转后不高亮）
  document.querySelectorAll('.nav a').forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = e.target.getAttribute('href').slice(1);
      currentNav.value = targetId;
    });
  });
});
</script>

<style scoped>
/* 导航（H5折叠适配） */
.header {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 99;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.logo h2 {
  color: var(--primary);
  font-size: 24px;
}

.nav-wrap {
  display: flex;
  align-items: center;
}

.nav ul {
  display: flex;
  gap: 30px;
}

.nav ul li a {
  font-size: 16px;
  font-weight: 500;
  transition: 0.3s;
}

.nav ul li a:hover {
  color: var(--primary);
}

/* 移动端导航折叠样式 */
@media (max-width: 768px) {
  .header-wrap {
    height: 70px;
  }

  .nav-wrap {
    position: fixed;
    top: 70px;
    right: 0;
    bottom: 0;
    width: 220px;
    background: var(--white);
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    transform: translateX(100%);
    transition: 0.3s;
    z-index: 99;
  }

  .nav-wrap.open {
    transform: translateX(0);
  }

  .nav ul {
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }

  .lang-switch {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .menu-btn span.active {
    opacity: 0;
  }

  .menu-btn span:nth-child(1).active {
    opacity: 1;
    transform: rotate(45deg) translate(5px, 5px);
  }

  .menu-btn span:nth-child(3).active {
    opacity: 1;
    transform: rotate(-45deg) translate(5px, -5px);
  }
}

/* banner（H5适配，调整高度） */
.banner {
  height: 500px;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://picsum.photos/id/1048/1920/600');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
}

.banner-content h1 {
  font-size: 48px;
  margin-bottom: 20px;
}

.banner-content p {
  font-size: 20px;
  margin-bottom: 30px;
}

/* 移动端banner调整 */
@media (max-width: 768px) {
  .banner {
    height: 350px;
  }

  .banner-content h1 {
    font-size: 32px;
  }

  .banner-content p {
    font-size: 16px;
  }

  .btn {
    padding: 10px 24px;
    font-size: 14px;
  }
}

/* 产品（响应式网格，H5适配） */
.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
}

.product-item {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
  transition: 0.3s;
}

.product-item:hover {
  transform: translateY(-5px);
}

.product-img {
  height: 220px;
}

.product-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  padding: 20px;
}

.product-info h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: var(--dark);
}

.product-info p {
  color: var(--gray);
  font-size: 14px;
}

/* 移动端产品列表调整 */
@media (max-width: 768px) {
  .product-list {
    gap: 20px;
  }

  .product-img {
    height: 180px;
  }

  .product-info h3 {
    font-size: 18px;
  }
}

/* 关于我们（H5适配，换行显示） */
.about-wrap {
  display: flex;
  gap: 40px;
  align-items: center;
  flex-wrap: wrap;
}

.about-img, .about-text {
  flex: 1;
  min-width: 300px;
}

.about-text p {
  margin-bottom: 15px;
  color: var(--gray);
  line-height: 1.8;
  font-size: 14px;
}

/* 案例（H5适配，图片横屏占满） */
.case-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.case-item {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.case-item img {
  height: 240px;
  object-fit: cover;
  width: 100%; /* 强制横屏占满容器 */
}

.case-name {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 10px;
  text-align: center;
  font-size: 14px;
}

/* 移动端案例调整 */
@media (max-width: 768px) {
  .case-item img {
    height: 180px;
  }
}

/* 联系我们（H5适配，换行显示） */
.contact-info {
  display: flex;
  justify-content: center;
  gap: 50px;
  flex-wrap: wrap;
  text-align: center;
}

.info-item {
  margin-bottom: 20px;
  min-width: 200px;
}

.info-item h3 {
  color: var(--primary);
  margin-bottom: 10px;
  font-size: 18px;
}

.info-item p {
  color: var(--gray);
  font-size: 14px;
}

/* 底部（H5适配，调整字体） */
.footer {
  background: var(--dark);
  color: white;
  text-align: center;
  padding: 30px 0;
}

.footer p {
  font-size: 14px;
  line-height: 1.8;
}

/* 移动端底部调整 */
@media (max-width: 768px) {
  .footer p {
    font-size: 12px;
  }
}
/* 导航选中样式：高亮+下划线 */
.nav ul li a.active {
  color: var(--primary); /* 主色高亮，与网站主色调统一 */
  font-weight: 600; /* 加粗增强视觉 */
  position: relative;
}
.nav ul li a.active::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--primary); /* 下划线与高亮色一致 */
  transition: 0.3s;
}

/* 移动端选中样式同步适配 */
@media (max-width: 768px) {
  .nav ul li a.active {
    padding-left: 10px;
    border-left: 2px solid var(--primary); /* 移动端新增左侧边框，增强选中识别 */
  }
  .nav ul li a.active::after {
    display: none; /* 移动端隐藏下划线，避免拥挤 */
  }
}
/* 备案信息优化样式 */
.beian-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 12px;
}
.beian-icon {
  width: auto;
  height: 32px;
  vertical-align: middle;
  object-fit: contain;
}
.beian-link {
  color: #fff;
  text-decoration: none;
}
.beian-link:hover {
  color: var(--primary);
}
</style>
